<template>
  <div class="cart-item">
    <span class="close" @click="removeFromCart(itemInfo.offer_id)">X</span>
    <b-row>
      <b-col cols="3" sm="2">
        <b-img :src="`https://offers-jo.easysooq.net/${itemInfo.item_image_path}`" fluid></b-img>
      </b-col>
      <b-col cols="9" sm="9">
        <h2>{{itemInfo.name}}</h2>
        <div class="price">
          <p>السعر {{itemInfo.selling_price}}</p>
          <p>الكمية {{itemInfo.quantity}}</p>
        </div>
      </b-col>
      <!-- <b-col cols="3" sm="2">
        <div class="quantaty">
          <p class="text-center">الكمية</p>
        </div>
      </b-col>
      <b-col cols="9" sm="9">
        <div class="quantaty">
            <VueNumericInput v-model="itemInfo.quantity"/>
        </div>
      </b-col> -->
    </b-row>
  </div>
</template>
<script type="text/javascript">
//import VueNumericInput from 'vue-numeric-input';
import {mapActions} from 'vuex'
  export default {
    name:'cartItem',
    props:['itemInfo'],
    //components:{VueNumericInput},
    data() {
      return {
        quan:1
      }
    },
    methods:{
      ...mapActions(["removeFromCart"]),
    }
  }
</script>
